import { render, staticRenderFns } from "./ProductTagView.vue?vue&type=template&id=4f050ae4&"
import script from "./ProductTagView.vue?vue&type=script&lang=js&"
export * from "./ProductTagView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports